// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2531":"e08662a2","8525":"39b8301f"}[chunkId] || chunkId) + "." + {"2090":"edd0c5875f6cdd13","2531":"02ccf561991012e9","5837":"d5bdf951f13dadb9","6779":"a837ef2f68e475ae","7663":"313a18e0774d7da0","8525":"deb013b3d22c004b","9357":"eedc4b62ce1fae36"}[chunkId] + ".js";
};